import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const BookingSummaryUpdatedItem = ({
  newContent,
  currentContent,
  testingId
}) => {
  return (
    <div data-testing-id={testingId}>
      <div className='flex center border-bottom'>
        <p style={{ flex: 0.2 }}>
          <span className='new-total-circle-icon' />
          <span>
            <FormattedMessage
              id='inbox.schedule_comparison.new'
              defaultMessage='New'
            />
          </span>
        </p>
        <div style={{ flex: 1, textAlign: 'right' }}>{newContent}</div>
      </div>
      <div className='flex center text-gray'>
        <p style={{ flex: 0.2 }}>
          <span>
            <FormattedMessage
              id='inbox.schedule_comparison.current'
              defaultMessage='Current'
            />
          </span>
        </p>
        <div style={{ flex: 1, textAlign: 'right' }}>{currentContent}</div>
      </div>
    </div>
  );
};

BookingSummaryUpdatedItem.propTypes = {
  newContent: PropTypes.element.isRequired,
  currentContent: PropTypes.element.isRequired,
  testingId: PropTypes.string
};
